// Client-safe slug→displayName map for /weeds deep links. Deliberately tiny:
// client components (diagnosis-results' weed-guide link) must NOT import the
// full editorial module in data/weeds/index.ts (~23KB minified of intros,
// cues, and FAQs — Codex Phase-4 review). A test asserts this map stays in
// sync with WEED_PAGES.

export const WEED_PAGE_SLUGS: Record<string, string> = {
  crabgrass: 'Crabgrass',
  dandelions: 'Dandelions',
  'white-clover': 'White Clover',
  'foxtail-setaria': 'Foxtail',
  goosegrass: 'Goosegrass',
  'broadleaf-plantain': 'Broadleaf Plantain',
  'nutsedge-yellow': 'Yellow Nutsedge',
  'creeping-charlie-ground-ivy': 'Creeping Charlie',
  'annual-bluegrass-poa-annua': 'Annual Bluegrass (Poa annua)',
  'spotted-spurge': 'Spotted Spurge',
  henbit: 'Henbit',
  'chickweed-common': 'Common Chickweed',
  'wild-violet': 'Wild Violet',
  quackgrass: 'Quackgrass',
  orchardgrass: 'Orchardgrass',
  'creeping-bentgrass': 'Creeping Bentgrass',
}

export function weedPageDisplayName(slug: string | undefined | null): string | undefined {
  return slug ? WEED_PAGE_SLUGS[slug] : undefined
}
